import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  downloadErrorsFileBtn: {
    color: themesConfig.default.colors.primary,
    border: `1px solid ${themesConfig.default.colors.primary}`,
    borderRadius: 4,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 'normal',
    backgroundColor: 'transparent !important',
    textDecoration: 'none !important',
    marginRight: 13,

    [useBreakpoints(theme).lessThan.md]: {
      marginRight: 0,
      marginBottom: 10,
      width: '100%',
    },

    '& svg': {
      marginRight: 8,
    },
  },
}))
